import type { TFunction } from 'i18next';

import { z } from 'zod';

import { isValidDateInput } from './date-input.ts';

export const createEducationSchema = (t: TFunction) =>
  z.object({
    school: z.string().min(1, t('Forms.Education.errors.school')),
    name: z.string().min(1, t('Forms.Education.errors.formationName')),
    degree: z.string().min(1, t('Forms.Education.errors.degree')),
    // City is optional (soft rule): an empty value is accepted.
    location: z
      .string()
      .nullable()
      .optional()
      .transform(value => value ?? ''),
    // Dates are optional and the month is never blocking:
    // the candidate can leave them empty or give the year alone.
    degreeStartedAt: z
      .string()
      .nullable()
      .optional()
      .refine(value => isValidDateInput(value ?? ''), t('Forms.Education.errors.dateInvalid'))
      .transform(value => (value == null || value === '' ? null : value)),
    degreeObtainedAt: z
      .string()
      .nullable()
      .optional()
      .refine(value => isValidDateInput(value ?? ''), t('Forms.Education.errors.dateInvalid'))
      .transform(value => (value == null || value === '' ? null : value)),
    acquiredSkills: z.array(z.string()).default([]),
  });

export type EducationFormValues = z.infer<ReturnType<typeof createEducationSchema>>;
